import { render, staticRenderFns } from "./modalleave.vue?vue&type=template&id=19ff81f1"
import script from "./modalleave.vue?vue&type=script&lang=js"
export * from "./modalleave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports